import React, { useState, setState, useEffect, createContext, useContext, useCallback, useMemo, useRef } from 'react';
import appInfo from '../../app-info.js';
import axios from 'axios';
import CustomStore from 'devextreme/data/custom_store';
import { custom } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';
import { ButtonGroup } from 'devextreme-react/button-group';
import ArrayStore from 'devextreme/data/array_store';
import Row from 'devextreme/ui/data_grid';
import { alert } from "devextreme/ui/dialog"
import notify from 'devextreme/ui/notify';
import DataGrid, {
    Scrolling,
    Column,
    Pager,
    Paging,
    FilterRow,
    FilterPanel,
    StateStoring,
    HeaderFilter,
    Button,
    GroupPanel,
    ColumnChooser,
    Editing,
    Lookup,
    Toolbar,
    RequiredRule,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { Tooltip } from 'devextreme-react/tooltip';
import ScrollView from 'devextreme-react/scroll-view';
import Guid from 'devextreme/core/guid';

import ButtonToolbar from 'devextreme-react/button';

import Form, { Item, EmptyItem, TabbedItem, Tab, TabPanelOptions, StringLengthRule, GroupItem, Label } from 'devextreme-react/form';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { CustomRule, PatternRule } from 'devextreme-react/validator';

import ColorCell from './ColorCell.js';
import { useAuth } from '../../contexts/auth.js';
import { useLocation } from 'react-router-dom'
import { createStore } from "devextreme-aspnet-data-nojquery";
import { FileUploader } from 'devextreme-react/file-uploader';
import { FileUploaderForm } from '../../components/index.js';

import './Forum.scss';
import { Template } from 'devextreme-react';

import highImportance from '../../Images/alert.png';

import {
    validationRules,
    positionEditorOptions,
    notesEditorOptions,
    phoneEditorOptions
} from '../../ValidationRulesAndEditorOptions.js';
import validationEngine from 'devextreme/ui/validation_engine';
import { Height } from 'devextreme-react/range-selector.js';





export default function App(props) {

    const validationGroupName = "gridForm";

    const statusDefaultSelected = ['10', '18', '3', '4', '8'];

    const [seed, setSeed] = useState(1);

    const url = appInfo.urlWebApi;
    const { user } = useAuth();
    const location = useLocation();
    var extraParam;

    class pageInfo {
        constructor(pageType, pageTypeUrl, pageTitle) {
            this.pageType = pageType;
            this.pageTypeUrl = pageTypeUrl;
            this.pageTitle = pageTitle;
        }
    }

    const gridRef = useRef();

    const [{ isNewRecord, visible, newGuid }, setPopupState] = useState({});
    const [formData, setData] = useState(null);

    const store = new CustomStore({
        key: 'ID',
        load: (loadOptions) => {
            return axios.get(url + '/api/Forum/Get?', { params: { internalKey: user.internalKey, userType: user.userType, idUser: user.id, idRef: user.id } });
        },
        insert: (values) => {
            return axios.post(url + '/api/Forum/Post?', null, { params: { values: JSON.stringify(values), internalKey: user.internalKey, userType: user.userType, userid: user.id, newid: newGuid } });
        },
        update: (key, values) => {
            return axios.put(url + '/api/Forum/Put?', null, { params: { key: key, values: JSON.stringify(values), internalKey: user.internalKey } });
        },
        remove: (key) => {
            return axios.delete(url + '/api/Forum/Delete', { params: { key: key, internalKey: user.internalKey } });
        },
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.xhrFields = { withCredentials: false };
        },
    });

    const dataSource = new DataSource({
        store: store,
        refreshMode: 'reshape'
    })


    function onAllowDettaglio(e) {
        if (user.userType === 0)
            return !(e.row.data.ID_CLIENTE_DATI_SEDE === user.id);
        else if (user.userType === 1 || user.userType === 2)
            return !(e.row.data.ID_ATTORE === user.id);
        else
            return true;
    }
    function onAllowEditing(e) {
        if (user.userType === 0)
            return (e.row.data.ID_CLIENTE_DATI_SEDE === user.id);
        else if (user.userType === 1 || user.userType === 2)
            return (e.row.data.ID_ATTORE === user.id);
        else
            return false;
    }
    function onAllowDeleting(e) {
        if (user.userType === 0)
            return (e.row.data.ID_CLIENTE_DATI_SEDE === user.id);
        else if (user.userType === 1 || user.userType === 2)
            return (e.row.data.ID_ATTORE === user.id);
        else
            return false;
    }

    function onAllowDeletingEmpty(e) {
        if (user.userType === 0)
            return !(e.row.data.ID_CLIENTE_DATI_SEDE === user.id);
        else if (user.userType === 1 || user.userType === 2)
            return !(e.row.data.ID_ATTORE === user.id);
        else
            return false;
    }


    function isImportant(e) {
        return (e.row.data.IMPORTANTE === true);
    }
    function isImportantEmpty(e) {
        return !(e.row.data.IMPORTANTE === true);
    }
    function isMarkedAsRead(e) {
        return (e.row.data.ID_LETTURA != null);
    }
    function isMarkedAsReadEmpty(e) {
        return !(e.row.data.ID_LETTURA != null);
    }




    // ALLEGATI

    const storeAllegati = new CustomStore({
        key: 'ID',
        load: (loadOptions) => {
            return axios.get(url + '/api/ForumAllegati/Get', { params: { internalKey: user.internalKey, idForum: formData.ID, newid: newGuid } });
        },
        remove: (data) => {
            return axios.delete(url + '/api/ForumAllegati/Delete', { params: { key: data.ID, internalKey: user.internalKey, idForum: formData.ID, newid: newGuid, namefile: data.NAME, tempPath: data.temp } });
        },
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.xhrFields = { withCredentials: false };
        },
    });

    const dataSourceAllegati = new DataSource({
        store: storeAllegati,
        refreshMode: 'reshape',
        // requireTotalCount: true,
    });

    function base64ToArrayBuffer(base64) {
        var binaryString = atob(base64);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    async function GetDocumento(data) {
        if (user) {
            const instance = axios.create({
                baseURL: url,
                timeout: 3000,
                headers: { 'X-Custom-Header': 'foobar' }
            });

            await instance.get('/api/ForumAllegati/DownloadFile', {
                params: { idAllegato: data.ID, internalKey: user.internalKey, idForum: formData.ID, newid: newGuid, namefile: data.NAME, tempPath: data.temp }
            })
                .then(function (response) {
                    var bytes = base64ToArrayBuffer(response.data.dataObject);

                    const url = window.URL.createObjectURL(new Blob([bytes]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.data.name); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(function () {
                    // imgLogo = { isOk: false, message: "Errore di connessione al servizio Web", data: null };
                })
                .finally(function () { });
        }
        else {
            return null;
        }
    }

    function downloadFile(e) {
        GetDocumento(e.row.data);
    }

    // FINE ALLEGATI

    //INIT EDIT FORM

    async function MarkAsUnread(e) {
        console.log(e);
        if (user) {
            const instance = axios.create({
                baseURL: url,
                timeout: 3000,
                headers: { 'X-Custom-Header': 'foobar' }
            });

            var value = null;

            await instance.put('/api/Forum/MarkAsUnread', null, {
                params: {
                    internalKey: user.internalKey,
                    id: e.row.data.ID,
                    idLettura: e.row.data.ID_LETTURA
                }
            })
                .then(function (response) {
                    value = response.data;
                })
                .catch(function () {
                    // imgLogo = { isOk: false, message: "Errore di connessione al servizio Web", data: null };
                })
                .finally(function () {
                    setSeed(Math.random());
                });

            return value;
        }
        else {
            return null;
        }
    }
    async function MarkAsRead(e) {

        if (e.ID_LETTURA === null) {
            if (user) {
                const instance = axios.create({
                    baseURL: url,
                    timeout: 3000,
                    headers: { 'X-Custom-Header': 'foobar' }
                });

                var value = false;

                await instance.put('/api/Forum/MarkAsRead', null, {
                    params: {
                        internalKey: user.internalKey,
                        id: e.ID,
                        userType: user.userType,
                        userid: user.id
                    }
                })
                    .then(function (response) {
                        value = true;
                    })
                    .catch(function () {
                        // imgLogo = { isOk: false, message: "Errore di connessione al servizio Web", data: null };
                    })
                    .finally(function () { });

                dataSource.reload();

                return value;
            }
            else {
                return null;
            }
        }
    }


    const showPopup = useCallback(async (isNewRecord, formData) => {

        if (formData.ID_LETTURA == null) {
            await MarkAsRead(formData).then(function (result) {
            });
        }

        var newGuid = new Guid().toString();
        setData(formData);
        setPopupState({ isNewRecord, visible: true, newGuid });
    }, []);

    const hidePopup = useCallback(() => {
        setPopupState({ visible: false });
    }, []);

    const confirmChanges = useCallback(async () => {
        const result = validationEngine.validateGroup(validationGroupName);

        if (!result.isValid)
            return;

        var resultDati = null;

        if (isNewRecord) {
            resultDati = await store.insert(formData);
        }
        else {
            resultDati = await store.update(formData["ID"], formData);
        }

        if (resultDati != null) {
            if (resultDati.data.result == 99) {
                notify(resultDati.data.message, 'error', 2000);
            } else {
                await store.load();

                hidePopup();
            }
        }
        else { notify('Errore fatale durante il salvataggio', 'error', 2000); }

    }, [isNewRecord, formData, hidePopup]);


    const confirmBtnOptions = useMemo(() => {
        return {
            text: "Salva",
            type: "success",
            onClick: confirmChanges
        }
    }, [confirmChanges]);

    const cancelBtnOptions = useMemo(() => {
        return {
            text: "Annulla",
            onClick: hidePopup
        }
    }, [hidePopup]);

    const editRow = useCallback((e) => {
        showPopup(false, { ...e.row.data });
    }, [showPopup]);

    const addRow = useCallback(async () => {
        showPopup(true, {});
    }, [showPopup]);

    function clearLocalStorage() {
        let customDeleteConfirmDialog = custom({
            showTitle: false,
            messageHtml: "Le personalizzazioni della griglia verrano eliminate. Sicuro di procedere voler procedere?",
            buttons: [{
                text: "Si",
                onClick: () => true
            }, {
                text: "No",
                onClick: () => false
            }]
        })

        customDeleteConfirmDialog.show().then((dialogResult) => {
            if (dialogResult) {
                gridRef.current.instance.state(null);
            }
        }).then(function () {
            dataSource.reload();
        })

    }

    function deleteRow(e) {
        let customDeleteConfirmDialog = custom({
            showTitle: false,
            messageHtml: "Sicuro di voler rimuore questo messaggio? Verranno eliminati anche eventuali file allegati.",
            buttons: [{
                text: "Si",
                onClick: () => true
            }, {
                text: "No",
                onClick: () => false
            }]
        })

        customDeleteConfirmDialog.show().then((dialogResult) => {
            if (dialogResult) {
                store.remove(e.row.data.ID);
            }
        }).then(function () {
            dataSource.reload();
        })
    }

    function deleteRowAllegati(e) {
        let customDeleteConfirmDialog = custom({
            showTitle: false,
            messageHtml: "Sicuro di voler rimuore questo allegato?",
            buttons: [{
                text: "Si",
                onClick: () => true
            }, {
                text: "No",
                onClick: () => false
            }]
        })

        customDeleteConfirmDialog.show().then((dialogResult) => {
            if (dialogResult) {
                storeAllegati.remove(e.row.data);
            }
        }).then(function () {
            dataSourceAllegati.reload();
        })
    }

    function getUrlUpload() {
        return url + '/api/ForumAllegati/Post?internalKey=' + user.internalKey + '&idForum=' + (isNewRecord ? 0 : formData.ID) + '&newid=' + newGuid;
    }

    function getBadgeNote() {
        return (formData.NOTE_CLIENTE ?? '').trim().length > 0 ? '1' : null;
    }

    function getBadgeAllegati() {
        return null;
    }

    function onChangeFileUpload(result, value) {
        dataSourceAllegati.reload();
    }

    function GetTitlePopup() {
        return isNewRecord ? 'Nuovo messaggio ' : 'Dettaglio messaggio ';
    }

    function onTitleClick(e) {
        if (e.itemIndex === 1) {
            dataSourceAllegati.reload();
        }
    }


    function isEditable() {
        if (user.userType === 0)
            return isNewRecord || (formData.ID_CLIENTE_DATI_SEDE === user.id);
        else if (user.userType === 1 || user.userType === 2)
            return isNewRecord || (formData.ID_ATTORE === user.id);
        else
            return false;
    }

    //END EDIT FORM  

    return (
        <React.Fragment>
            <h2 className={'content-block'}>Chat</h2>

            <DataGrid
                id='gridContainer'
                className={'dx-card wide-card'}
                dataSource={dataSource}
                ref={gridRef}
                showBorders={false}
                focusedRowEnabled={true}
                defaultFocusedRowIndex={0}
                repaintChangesOnly={true}
                allowColumnResizing={true}
                useNative={true}
                allowColumnReordering={true}
            >
                <Scrolling showScrollbar='always' mode='standard'></Scrolling>
                <Pager showPageSizeSelector={true} allowedPageSizes={[20, 40, 60]} showInfo={true} showNavigationButtons={true} visible={true} />
                <Paging defaultPageSize={20} />
                <HeaderFilter visible={true} />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <ColumnChooser enabled={true} mode="select" height={600} width={320} allowSearch={false} />
                <GroupPanel visible={true} emptyPanelText="Trascinare qui le intestazioni di colonna per creare raggruppamenti..." />
                <StateStoring enabled={true} type="localStorage" storageKey='storageForum,' />

                <Column dataField={'ID'} width={90} visible={false} />

                <Column type="buttons" width={120} caption="AZIONI" fixed={true} fixedPosition="left" >
                    <Button icon="doc" visible={onAllowDettaglio} onClick={editRow} />
                    <Button name="edit" visible={onAllowEditing} onClick={editRow} />
                    <Button name="delete" visible={onAllowDeleting} onClick={deleteRow} />
                    <Button icon="emptyvalue" visible={onAllowDeletingEmpty} disabled={true} />
                    <Button icon="warning" hint="Importante" visible={isImportant} />
                    <Button icon="emptyvalue" visible={isImportantEmpty} disabled={true} />
                    <Button icon="ion ion-home" hint="Segna come da leggere" visible={isMarkedAsRead} onClick={MarkAsUnread} />
                    <Button icon="emptyvalue" visible={isMarkedAsReadEmpty} disabled={true} />
                </Column>
                <Column
                    dataField={'MITTENTE'}
                    caption={'Mittente'}
                    width={200}
                    visible={true}
                    sortOrder="desc"
                    allowEditing={false}
                    minWidth={200}
                />

                <Column
                    dataField={'DATA'}
                    width={120}
                    caption={'Data'}
                    dataType="date"
                    visible={true}
                    format="dd-MM-yyyy"
                />
                <Column
                    dataField={'OGGETTO'}
                    columnAutoWidth={true}
                    caption={'Oggetto'}
                    visible={true}
                />
                <Column
                    dataField={'MESSAGGIO'}
                    columnAutoWidth={true}
                    caption={'Messagio'}
                    visible={true}
                />

                <Toolbar>
                    <Item>
                        <ButtonToolbar icon="add" onClick={addRow} text="Nuovo messaggio" stylingMode="text" />
                    </Item>
                    <Item name="columnChooserButton" />
                    <Item>

                        <ButtonToolbar id="clearLocalStora" icon="clearformat" onClick={clearLocalStorage} text="" />

                        <Tooltip
                            target="#clearLocalStora"
                            showEvent="mouseenter"
                            hideEvent="mouseleave"
                            hideOnOutsideClick={false}
                        >
                            <div>Pulisci personalizzazione griglia</div>
                        </Tooltip>

                    </Item>
                </Toolbar>
            </DataGrid>


            {visible ? (

                <Popup
                    title={GetTitlePopup()}
                    hideOnOutsideClick={true}
                    visible={true}
                    width={900}
                    height={750}
                    onHiding={hidePopup}
                >
                    <ToolbarItem
                        visible={isEditable()}
                        widget="dxButton"
                        location="after"
                        toolbar="bottom"
                        options={confirmBtnOptions}
                    />
                    <ToolbarItem
                        widget="dxButton"
                        location="after"
                        toolbar="bottom"
                        options={cancelBtnOptions}
                    />

                    <Form
                        id="form"
                        colCount={1}
                        encType="multipart/form-data"
                        validationGroup={validationGroupName}
                        formData={formData}
                    >

                        <Item itemType="group">
                            <Item dataField="OGGETTO" colSpan={2} >
                                <Label text={`Oggetto`} />
                                <RequiredRule />
                            </Item>
                            <Item dataField="IMPORTANTE" editorType="dxCheckBox" colSpan={1} editorOptions={{ iconSize: 25, height: 45 }} >
                                <Label text={`Importante`} />
                            </Item>
                            <Item dataField="MESSAGGIO" editorType="dxTextArea" colSpan={3} editorOptions={{ height: 370 }}>
                                <Label text={`Messaggio`} />
                                <RequiredRule />
                            </Item>

                        </Item>

                    </Form>

                </Popup>
            ) : null}

        </React.Fragment>
    )
};